import React from 'react';
import { steps } from '../data/content';
export function HowItWorks() {
  return <section className="bg-ivory-light py-10 sm:py-14" aria-labelledby="how-title" data-id="element-93" data-mp="7slq0yyp41rl">
      <div className="mx-auto max-w-4xl px-5 sm:px-8" data-id="element-94" data-mp="7qis7srax4cb">
        <h2 id="how-title" className="text-center font-display text-[22px] font-semibold uppercase leading-[1.15] tracking-tightish text-navy-deep sm:text-3xl" data-id="element-95" data-mp="3pzt9jvk6sv6j">
          From “what do I use today?”
          <br data-id="element-96" data-mp="lmcxm1sv9bko" />
          to ready in minutes.
        </h2>

        <ol className="mt-6 grid gap-3 sm:mt-8 sm:grid-cols-3 sm:gap-5" data-id="element-97" data-mp="qibihfezkbgc">
          {steps.map(step => <li key={step.number} className="flex items-start gap-3 sm:flex-col sm:items-center sm:gap-2 sm:text-center" data-id="element-98" data-mp="cr6qmzhv0ngk">
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-teal font-display text-sm font-semibold text-ivory-light" data-id="element-99" data-mp="14imawmvy1y3m">
                {step.number}
              </span>
              <div data-id="element-100" data-mp="2rkwdky870bmw">
                <h3 className="text-[13.5px] font-semibold uppercase tracking-[0.1em] text-navy-deep sm:text-base" data-id="element-101" data-mp="2rmftuotummoo">
                  {step.title}
                </h3>
                <p className="mt-0.5 text-[12.5px] leading-snug text-navy-soft sm:text-sm" data-id="element-102" data-mp="31bzdvxtasml4">
                  {step.detail}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}